module.exports = __webpack_public_path__ + "static/img/index_image03.e96dcd8b.png";